import axios from './axiosInstance';

const USER_ROLE = 'admin';

export const login = async ({
  email,
  password
}) => {
  try{
    const response = await axios({
      url : '/login',
      method : 'POST',
      data : {
        email : email,
        password : password,
        role : USER_ROLE
      }
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const getLoggedInUser = async () => {
  try{
    const response = await axios({
      url : '/get-logged-in-user'
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const uploadProfilePicture = async ({
  data
}) => {
  try{
    const response = await axios({
      url : '/upload-profile-picture',
      method : 'POST',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const updateUser = async ({
  data,
  id
}) => {

  try{
    const response = await axios({
      url : `/update-user/${id}`,
      method : 'PUT',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const updatePassword = async ({
  data
}) => {
  try{
    const response = await axios({
      url : '/update-password',
      method : 'POST',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const sendPasswordResetMail = async ({
  email
}) => {
  try{
    const response = await axios({
      url : '/send-password-reset-email',
      method : 'POST',
      data : {
        email : email,
        role : USER_ROLE
      }
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const resetPassword = async ({
  password,
  token
}) => {
  try{
    const response = await axios({
      url : '/reset-password',
      method : 'POST',
      headers : {
        'Authorization' : token
      },
      data : {
        password
      }
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}